import React from 'react';

import { FormField, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import { MILITARY_FACILITIES } from '../../../constants';
import YesAndNo from '../../../../shared/components/Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function MilitaryFacilities({ section, setSectionValues }: Props) {
  function onNoMilitaryFacilities(): void {
    setSectionValues({
      [MILITARY_FACILITIES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesMilitaryFacilities(): void {
    setSectionValues({
      [MILITARY_FACILITIES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <FormField
      label={
        <Label size="lg">
          Is the property located within one mile of an abandoned or closed military base where ammunition or military
          explosives were used?
        </Label>
      }
      control={
        <YesAndNo
          yesHandler={onYesMilitaryFacilities}
          noHandler={onNoMilitaryFacilities}
          yesActive={section.getFieldValue(MILITARY_FACILITIES.FIELD_NAME.IS_ENABLED)}
        />
      }
    />
  );
}

MilitaryFacilities.description = 'Asks whether or not the property is near a military facility';

export default MilitaryFacilities;
